import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import CardBlog from "./CardBlog";

const ListNews: React.FC = () => {
  const data = useStaticQuery(graphql`
    {
      allSitePage(limit: 3) {
        nodes {
          id
          path
          context {
            slug
            date
            title
            body
            image
          }
        }
      }
    }
  `);

  return (
    <div className="container">
      <div className="mx-2 mb-6 pb-6">
        <h1 className="is-size-3-mobile title-blog-baseline-title my-6">
          Todas as Notícias
        </h1>

        <div className="columns is-flex-wrap-wrap	mx-0">
          {data.allSitePage.nodes.map((noticia, i) => (
            <div key={i} className="column is-one-third">
              <CardBlog
                key={i}
                image={noticia.context.image || "/no-image.png"}
                date={noticia.context.date}
                title={noticia.context.title}
                slug={noticia.context.slug}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListNews;
